import { Box } from "@chakra-ui/react";
import { Loader } from "../Loader/Loader";

export const LoaderScreen = () => (
  <Box
    width="100%"
    height="100%"
    flex={1}
    alignItems="center"
    justifyContent="center"
    display="flex"
  >
    <Loader />
  </Box>
);
